import { render, staticRenderFns } from "./VideoInstruction.vue?vue&type=template&id=88681974&"
import script from "./VideoInstruction.vue?vue&type=script&lang=js&"
export * from "./VideoInstruction.vue?vue&type=script&lang=js&"
import style0 from "./VideoInstruction.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports